import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

interface ConnectionInstructionsProps {
  payerName: string;
  portalUrl?: string;
}

export const ConnectionInstructions = ({
  payerName,
  portalUrl,
}: ConnectionInstructionsProps) => {
  return (
    <div className="vai-w-[45%]">
      <h3 className="vai-font-semibold vai-mb-4">
        <Trans>How to Set Up Your Videa Verification Agent:</Trans>
      </h3>
      <ol className="vai-space-y-3 vai-list-decimal vai-list-outside vai-pl-6">
        <li>
          <Trans>Sign in to the</Trans>{' '}
          <a
            href={portalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="vai-text-sapphire-600 hover:vai-underline vai-inline-flex vai-items-center vai-gap-1"
          >
            {payerName} <Trans>payer portal</Trans>
            <FontAwesomeIcon
              icon={faExternalLink}
              className="vai-w-3 vai-h-3"
            />
          </a>
          .
        </li>
        <li>
          <Trans>
            Follow portal instructions for creating a new{' '}
            <strong>admin-level</strong> user with the information provided.
          </Trans>
        </li>
        <li>
          <Trans>
            Check the email address you provided us (usually the office email)
            for confirmation that the new account was created.
          </Trans>
        </li>
        <li>
          <Trans>
            Follow portal instructions to set up the new user. If the portal
            requires multi-factor authentication, you will receive a code to the
            email address you provided.
          </Trans>
        </li>
        <li>
          <Trans>
            Return to this page and click the &quot;Test Connection&quot; button
            to verify that the verify agent was connected.
          </Trans>
        </li>
      </ol>
    </div>
  );
};
